module.exports = __webpack_public_path__ + "media/registration/conferences@1x-5164d593.png";